import Tabs from '../layout/Tabs';

type Props = {
  active: 'flags' | 'clinics';
};

const FlagsNavigation = ({ active }: Props) => (
  <Tabs
    tabs={[
      { name: 'Feature flags', href: '/flags', active: active === 'flags' },
      { name: 'Clinics by group', href: '/flags/clinics', active: active === 'clinics' },
    ]}
  />
);

export default FlagsNavigation;
